import { Label, Stack } from "@/app/design-system";
import {
  DeprecatedComposedReachUISelect,
  Option,
} from "@/app/design-system/select-reachui/composed-select-reachui";
import React from "react";
import { useController, useFormContext, useWatch } from "react-hook-form";

import { CancelClientGroupEventFieldNames } from "../../_api/use-cancel-client-group-event-form/use-cancel-client-group-event-form";

interface CancellationFormItemProps {
  name: string;
  options: Option[];
  id?: string;
  callback: () => void;
}

export const CancellationReasonFormItem = ({
  name,
  options,
  id,
  callback,
}: CancellationFormItemProps) => {
  const { control } = useFormContext();

  const selectedCancellationReason = useWatch({
    name: CancelClientGroupEventFieldNames.CANCELLATION_REASON,
    control,
  });

  const selectedCancellationType = useWatch({
    name: CancelClientGroupEventFieldNames.CANCELLATION_TYPE,
    control,
  });

  const {
    field: { value, onChange, onBlur, ref },
    fieldState: { invalid, isDirty },
    formState: { errors },
  } = useController({
    name,
    control,
  });

  return (
    <Stack gap={10}>
      <Label required>Cancellation reason</Label>
      <DeprecatedComposedReachUISelect
        id={id}
        options={options}
        value={selectedCancellationReason}
        onChange={(value) => {
          onChange(value);
          callback();
        }}
        disabled={selectedCancellationType === "Select"}
        selectRootName={"Cancellation reason"}
      />
    </Stack>
  );
};
